module.exports = __webpack_public_path__ + "static/media/News-Surf.8e77c7f6.svg";